import { Page } from '../components';
import { ParcelInvoiceManagement } from '../components/ParcelInvoiceManagement';

export const Home = () => <Page render={() => <ParcelInvoiceManagement />} />;
